export enum LocalStorageKey {
  CART = "cart",
  SERVICE_CART = "serviceCart",
  TABLE_DATA = "tableData",
  DELIVERY_ADDRESS = "deliveryAddress",
  BOOKED_SERVICE_CART = "bookedServiceCart",
  SCAN_TO_ORDER_INFO = "scanToOrderInfo",
  GIFT_CARD = "giftCard",
  TEST_KEY = "testKey",
  COOKIE_BANNER_SEEN = "cookieBannerSeen",
  NEWCOLO_ONLOADPOP_ISTOUCHED = "newcolo_onloadpop_istouched",
  SCANTOORDER_WELCOME_MODAL_TOUCED = "scantoorder_welcome_modal_touched",
}

export enum SessionStorageKey {
  GIFT_CARD_INFO = "giftCardInfo",
  ORDER_ESTIMATES = "orderEstimates",
  SCHEDULED_TIME = "scheduledTime",
  RECEIPT_ID = "receiptId",
  PICKUP_TIME = "pickupTime",
  DELIVERY_TRACKING_URL = "deliveryTrackingUrl",
  CAN_ACCESS_CONFIRMATION = "canAccessConfirmation",
  ORDER_DETAILS = "orderDetails",
  TEST_KEY = "testKey",
  ONLOAD_SCHEDULEDORDER_POPUP_ISTOUCHED = "onload_scheduledOrderPopup_isTouched",
}
